import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import meImg from "./assets/me-img2.png";
import catImg from "./assets/cat.png";
import "./About.css";
import Footer from "./Footer";

const About = () => {
  return (
    <div>
      <div className="about-page">
        <Helmet>
          <title>About | Attoli</title>
          <meta
            name="description"
            content="Learn more about Attoli and the founder behind the website growth and management services."
          />
        </Helmet>

        <section className="about-page-section">
          <div className="about-card">
            <img
              src={catImg}
              alt="Cat illustration"
              className="about-image about-image-cat"
            />
            <img
              src={meImg}
              alt="Portrait of Mac O"
              className="about-image about-image-me"
            />

            <div className="about-card-content">
              <h1>About Attoli</h1>
              <p>
                Hi! I'm Mac O. I help solo accountants and small accounting
                firms grow through smart CPA marketing. I have a background in
                web development and website growth. I build and manage websites
                that are easy to use and easy to find online.
              </p>
              <p>
                I blend web development, content creation, ongoing site care,
                and monthly reporting so your online presence feels polished and
                reliable without taking up your time.
              </p>
              <p>
                My goal is simple. I want your firm to stand out. I want your
                website to work for you every single day. Not just sit there
                doing nothing collecting dust. I offer full CPA website
                services. This includes content writing, ongoing site
                management, any site updates, creation of free tools/ linkable
                assets, and SEO keyword generation. You focus on your clients. I
                focus on your website and growth. If you run a solo practice or
                a small accounting firm you deserve a website that works as hard
                as you do.
              </p>

              <Link to="/contact" className="about-page-link">
                Let’s connect
              </Link>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default About;
